import React, { useContext } from 'react';
import { Chip } from '@ubeya/shared-web/components';
import { RequestTypes, TYPES_COLROS } from '@ubeya/shared/hooks/generic/useRequestsTypes';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const TypeRenderer = ({ rowData: { typeId, data }, columnData: { mappedRequestsTypes, mappedLeaveTypes } }) => {
  const { t } = useContext(ConfigContext);
  const { label, background, color, isRawLabel } =
    (() => {
      switch (typeId) {
        case RequestTypes.ABSENCE:
          return mappedRequestsTypes?.[typeId]?.kinds?.[data?.jobTypeId] || {};

        case RequestTypes.GENERAL_AVAILABILITY:
          return { label: mappedRequestsTypes?.[typeId]?.type, ...TYPES_COLROS[RequestTypes.GENERAL_AVAILABILITY] };

        case RequestTypes.RELEASE_SHIFT:
          return { label: mappedRequestsTypes?.[typeId]?.type, ...TYPES_COLROS[RequestTypes.RELEASE_SHIFT] };

        case RequestTypes.SWAP_SHIFT:
          return { label: mappedRequestsTypes?.[typeId]?.type, ...TYPES_COLROS[RequestTypes.SWAP_SHIFT] };

        case RequestTypes.LEAVE_REQUEST: {
          const leaveTypeName = mappedLeaveTypes?.[data?.accountLeaveTypeId]?.name;
          return leaveTypeName
            ? { label: leaveTypeName, isRawLabel: true, ...TYPES_COLROS[RequestTypes.LEAVE_REQUEST] }
            : { label: 'leave-request', ...TYPES_COLROS[RequestTypes.LEAVE_REQUEST] };
        }

        default:
          break;
      }
    })() || {};

  return <Chip label={isRawLabel ? label : t(label)} background={background} color={color} />;
};

export default TypeRenderer;
